import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SalesPortalDetailHeaderAddressFieldsFragmentDoc,
  SalesPortalDetailHeaderChatFieldsFragmentDoc,
} from '@/experiences/sales-portal/blocs/documents/sales-portal-detail-header-fragments.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountDetailsDocument = gql`
  query SalesPortalAccountDetails(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    restaurant: businesses_by_pk(uuid: $restaurantUUID) {
      address {
        ...SalesPortalDetailHeaderAddressFields
        address2
        country_code
        timezone
      }
      name
      restaurant_chats(
        limit: 1
        where: { supplier_uuid: { _eq: $supplierUUID } }
      ) {
        ...SalesPortalDetailHeaderChatFields
        restaurant_notes
        show_app_payments_tab
        status
      }
      uuid
    }
    businessDetails: getBusinessDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      hours {
        open {
          day
          end
          is_overnight
          start
        }
      }
    }
  }
  ${SalesPortalDetailHeaderAddressFieldsFragmentDoc}
  ${SalesPortalDetailHeaderChatFieldsFragmentDoc}
`;
export function useSalesPortalAccountDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >(SalesPortalAccountDetailsDocument, options);
}
export function useSalesPortalAccountDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >(SalesPortalAccountDetailsDocument, options);
}
export type SalesPortalAccountDetailsQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailsQuery
>;
export type SalesPortalAccountDetailsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailsLazyQuery
>;
export type SalesPortalAccountDetailsQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountDetailsQuery,
  Types.SalesPortalAccountDetailsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountDetailsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >(SalesPortalAccountDetailsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountDetailsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountDetailsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountDetailsQuery,
    Types.SalesPortalAccountDetailsQueryVariables
  >(SalesPortalAccountDetailsDocument, lazyOptions);
}
